module.exports = __webpack_public_path__ + "static/img/国医大师王琦.17debeb7.png";